import React from 'react'
import TableFixedPage from '../../TableFixedPage/TableFixedPage';
import DeliveredOrderPeykTable from '../../Tables/AllOrderPeyk/DeliveredOrderPeykTable/DeliveredOrderPeykTable';
import { useState } from 'react';
import { useEffect } from 'react';
import { getOrdersDeliveredApi, getOrdersListApi, getUserInfoApi } from '../../../Api/PanelAdminServices';
import { errorToast } from '../../../Utils/Toast/Toast';

const DeliveredOrderPeykContainer = () => {
  /////get order delivered////////
  const [orderDelivered, setOrderDelivered] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [Info, setInfo] = useState([]);
  const [address, setAddress] = useState();

  useEffect(() => {
    getOrdersDelivered();
  }, []);
  const getOrdersDelivered = async () => {
    getOrdersDeliveredApi((succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          const filteredData=res.orders.filter(el=>{
            if(el.status==="3"){
              return el.order_type==="magic"
            }else return false
          })
          setOrderDelivered(filteredData);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  console.log(orderDelivered)
  const showOrder = async (info) => {
    setIsOrderVisible(true);
    getOrdersListApi(info.key, 0, (succ, res) => {
      if (succ) {
        if (res.status === 0) {
          errorToast("مشکلی پیش آمده است");
        } else {
          setOrderList(res.orders);
        }
      } else {
        errorToast("خطایی در سرور رخ داده است");
      }
    });
  };
  const [isOrderVisible, setIsOrderVisible] = useState(false);
  const handleOkOrder = () => {
    setIsOrderVisible(false);
  };
  //////modal user info////////////
  const [isModalVisible, setIsModalVisible] = useState(false);
  const showModal = async (info) => {
    const result = await getUserInfoApi(info.userId);
    setInfo(info);
    setAddress(info.address);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };
  const data =
    orderDelivered &&
    orderDelivered.map((item) => {
      return {
        key: item.id,
        userId: item.user_id,
        person: item.user_fullname,
        city: item.city,
        orderNumber: item.id,
        orderDate: item.date,
        deliverDate: item.deliver_date,
        score: item.score,
        address: item.address,
        phone: item.phone,
      };
    });
  return (
    <div>
      {/* <Modal
        width={350}
        title="اطلاعات شخص"
        open={isModalVisible}
        onOk={handleOk}
        footer={null}
      >
        <UserInfo
          showAddress={true}
          address={address}
          Info={Info}
          handleOk={handleOk} 
        />
      </Modal>
      <Modal
        width={400}
        title="لیست سفارش"
        open={isOrderVisible}
        onOk={handleOkOrder}
        footer={null}
      >
        <OrderList item={orderList} handleOk={handleOkOrder} />
      </Modal> */}
      <TableFixedPage title="سفارشات تحویل داده شده" />
      <DeliveredOrderPeykTable
        showOrder={showOrder}
        showModal={showModal}
        data={data}
      />
    </div>
  );
};

export default DeliveredOrderPeykContainer